import { handleActions } from 'redux-actions';

import { URLS_ACTIONS } from '../constants';

const initialState = {};

const saveUrls = (state, { payload }) => ({
	...state,
	...payload,
});

export default handleActions(
	{
		[URLS_ACTIONS.save_urls]: saveUrls,
	},
	initialState,
);
